import styled, { css } from "styled-components";
import { COLORS, fontMixins } from "../../../../styles";

interface GoodItemContainerProps {
	isPopular: boolean;
}

export const GoodItemContainer = styled.div<GoodItemContainerProps>`
	position: relative;
	display: flex;
	width: 224px;
	border-radius: 15px;
	border: 1px solid #e0d2ca;
	background: #fafafa;
	padding: 27px 27px 32px;
	flex-direction: column;
	min-height: 350px;

	${(props) =>
		props.isPopular &&
		css`
			border-radius: 0 0 15px 15px;
			background: #fffcee;

			${GoodRate} {
				background: #000;
				color: #fff;
			}

			&:before {
				content: "Most popular";
				position: absolute;
				background: #d89f5b;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 224px;
				height: 30px;
				left: -1px;
				top: -22px;
				border-radius: 6px 6px 0 0;
				${fontMixins(10, 400)};
				letter-spacing: 1.1px;
				color: #fff;
				text-transform: uppercase;
			}
		`}
`;

export const GoodRate = styled.div`
	display: flex;
	align-self: self-start;
	border-radius: 3px;
	background: #ebebeb;
	${fontMixins(12, 500)};
	color: #282828;
	line-height: 20px;
	padding: 0 8px;
	margin-bottom: 23px;
`;

export const GoodPrice = styled.div`
	display: inline-flex;
	${fontMixins(35, 600)};
	color: #191919;
`;

export const GoodCurrency = styled.div`
	display: inline-flex;
	${fontMixins(16, 600)};
	padding-top: 8px;
	margin-right: 3px;
`;

interface GoodPriceDescriptionProps {
	$paymentTerms: string;
}

export const GoodPriceDescription = styled.div<GoodPriceDescriptionProps>`
	display: flex;
	${fontMixins(12, 500)};
	color: #937e72;
	line-height: 25px;
	margin: 15px 0 10px;

	${(props) =>
		props.$paymentTerms === "For Beginners" &&
		css`
			color: ${COLORS.School};
		`}

	${(props) =>
		props.$paymentTerms === "For Advanced" &&
		css`
			color: ${COLORS.College};
		`}

  ${(props) =>
		props.$paymentTerms === "For Professionals" &&
		css`
			color: ${COLORS.University};
		`}
`;

export const GoodDivider = styled.div`
	display: flex;
	height: 1px;
	width: 100%;
	background: #e0d2ca;
	margin-bottom: 22px;
`;

export const GoodList = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 30px;
`;

export const GoodListItem = styled.div`
	display: flex;
	${fontMixins(10, 500)};
	line-height: 25px;

	svg {
		position: relative;
		top: 5px;
		display: flex;
		width: 8px;
		margin-right: 5px;

		path {
			stroke: #d89f5b;
		}
	}
`;

export const PurchasedPlanBadge = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: 34px;
	padding: 8px 14px;
	border-radius: 6px;
	background: #f7ead7;
	color: #9b6a2e;
	font-size: 13px;
	font-weight: 600;
	text-align: center;
	margin-top: auto;
`;

export const PurchasedPlanDate = styled.span`
	margin-top: 3px;
	font-size: 11px;
	font-weight: 500;
	color: #9b6a2e;
	opacity: 0.8;
`;
